import { connect } from "react-redux";
import { toast } from "react-toastify";
import * as C from "../components/cart/cart-styles";
import Layout from "../components/layout/Layout";
import { addToCart } from "../redux/action/cart";
import { priceComma } from "../common/splicePrice";
import Link from "next/link";
import { useEffect, useState } from "react";
import { deleteFavorites, fetchFavorites } from "../api/favorites";
import { failAlert, successAlert } from "../common/alert";
import { useRouter } from "next/router";
import { getCookie } from "../common/auth";
import {
  insertBasketsAction,
  fetchBasketsAction,
} from "../redux/action/baskets";
import {
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
} from "../redux/action/confirm";
import { isLoading, isLoaded } from "../redux/action/loading";
import { getUserInfo } from "../api/getUserInfo";
import * as _ from "lodash";
import { SeoMeta } from "@/utils/seo/SeoMeta";

const Wishlist = ({
  cartItems,
  basketsItems,
  addToCart,
  insertBasketsAction,
  fetchBasketsAction,
  modifyConfirmModal,
  openConfirmModal,
  closeConfirmModal,
  isLoading,
  isLoaded,
}) => {
  const router = useRouter();
  const [isUser, setIsUser] = useState(false);
  const [wishlist, setWishlist] = useState([]);
  const [mouseOn, setMouseOn] = useState({});

  // orderType 이 'O' 이거나 없으면 장바구니 허용
  const isOrderTypeO = (product) =>
    !product.orderType || product.orderType === "O";

  // 유저 체크
  const checkUser = async () => {
    isLoading();
    const res = await getUserInfo();

    if (res.code === "0000") {
      isLoaded();
      setIsUser(true);
    }

    if (res.code !== "0000") {
      failAlert("로그인을 하셔야 해당 서비스를 이용하실 수 있습니다.");
      isLoaded();
      router.push("/login");
      return;
    }
  };

  // 장바구니 등록
  const handleCart = async (product) => {
    // orderType 이 O 가 아니면 장바구니 불가
    if (product.orderType && product.orderType !== "O") {
      return failAlert("장바구니 담기가 불가능한 상품입니다.");
    }

    if (
      (!getCookie("token") ? cartItems : basketsItems)?.find(
        (item) => item.pcode === product.pcode
      )
    ) {
      return failAlert("이미 담겨있는 상품입니다");
    }
    // 채널톡 장비구니 이벤트
    window.ChannelIO("track", "AddToCart", {
      pcode: product.pcode,
    });
    if (!getCookie("token")) {
      return addToCart(product);
    } else {
      return insertBasketsAction(product, 1);
    }
  };

  // 위시리스트 리스트
  const fetchWishList = async () => {
    const body = {
      modes: "ListSet",
    };
    const data = await fetchFavorites(body);
    setWishlist(data?.data);
  };

  // 위시리스트 삭제
  const deleteWishlist = async (product) => {
    const body = {
      modes: "DeleteSet",
      pcode: product.pcode,
    };
    const data = await deleteFavorites(body);
    if (data?.code === "0000") {
      fetchWishList();
      successAlert(data.msg);
    }
    if (data?.code === "9999") return failAlert(data.msg);
  };

  // 삭제 모달
  const handleDelete = (product) => {
    const content = {
      title: "삭제하시겠습니까?",
      actionBtnLabel: "확인",
      actionBtnValid: true,
      cancelBtnLabel: "취소",
      onAction: () => {
        deleteWishlist(product), closeConfirmModal();
      },
    };
    modifyConfirmModal(content);
    openConfirmModal();
  };

  const onClickToDetail = (ename, pcode) => () => {
    router.push(`/products/${ename}/${pcode}/`);
  };

  // debounce 실행
  const executeDebounce = _.debounce(() => {
    checkUser();
  }, 100);

  useEffect(() => {
    executeDebounce();
    fetchWishList();
  }, []);

  return (
    <>
      <Layout
        parent="홈"
        sub="위시리스트"
        pageTitle={SeoMeta.wishlist.title}
        pageDesc={SeoMeta.wishlist.description}
        pageKeyword={SeoMeta.wishlist.keywords}
      >
        <section className="mt-50 mb-50">
          {isUser && (
            <div className="container">
              <div className="row">
                {wishlist?.length > 0 && (
                  <div className="col-lg-12 mb-40">
                    <h1 className="heading-2 mb-10 col-lg-12">위시리스트</h1>
                    <div className="d-flex justify-content-between">
                      <h6 className="text-body">
                        총{" "}
                        <span className="text-brand">{wishlist?.length}</span>
                        개의 상품이 위시리스트에 담겨있습니다.
                      </h6>
                    </div>
                  </div>
                )}
                <div className="col-lg-12">
                  <C.CartProductsWrapper>
                    {wishlist?.length > 0 ? (
                      <table className="table">
                        <thead>
                          <tr className="main-heading">
                            <th
                              className="custome-checkbox start pl-30"
                              colSpan="2"
                              style={{
                                width: "40%",
                                textAlign: "center",
                              }}
                            >
                              상품
                            </th>
                            <th>가격</th>
                            <th>재고</th>
                            <th>장바구니 담기</th>
                            <th className="end">삭제</th>
                          </tr>
                        </thead>
                        <tbody>
                          {wishlist?.map((product, i) => (
                            <tr key={i}>
                              <td className="image product-thumbnail pt-40">
                                <Link
                                  href={`/products/${product.ename}/${product.pcode}/`}
                                >
                                  <img
                                    src={product.main_image}
                                    alt=""
                                    style={{ cursor: "pointer" }}
                                  />
                                </Link>
                              </td>
                              <td className="name">
                                <h6 className="name">
                                  <Link
                                    href={`/products/${product.ename}/${product.pcode}/`}
                                  >
                                    <a>{product.pname}</a>
                                  </Link>
                                </h6>
                              </td>
                              <td className="price" data-title="가격">
                                <h6 className="">
                                  {priceComma(product.discount_price)}원
                                </h6>
                              </td>
                              <td
                                className="text-center detail-info"
                                data-title="재고"
                              >
                                {product.stock === 0 ? (
                                  <span className="stock-status out-stock mb-0">
                                    재고 없음
                                  </span>
                                ) : (
                                  <span className="stock-status in-stock mb-0">
                                    재고 있음
                                  </span>
                                )}
                              </td>
                              <td
                                className="text-right"
                                data-title="Cart"
                                style={{
                                  width: "20%",
                                  textAlign: "center",
                                }}
                              >
                                {/* 재고 0인 경우 기존 그대로 */}
                                {product.stock === 0 ? (
                                  <button
                                    className="btn btn-sm btn-secondary"
                                    disabled
                                  >
                                    문의 필요
                                  </button>
                                ) : !isOrderTypeO(product) ? (
                                  /* orderType 이 O 가 아닐 때: 장바구니 불가 */
                                  <button
                                    className="btn btn-sm btn-secondary"
                                    disabled
                                  >
                                    문의 상품
                                  </button>
                                ) : (
                                  /* 일반 장바구니 로직 (orderType O / 미지정) */
                                  ((!isUser
                                    ? cartItems?.find(
                                        (cartItem) =>
                                          cartItem.pcode === product.pcode
                                      )
                                    : basketsItems?.find(
                                        (basketsItem) =>
                                          basketsItem.pcode === product.pcode
                                      )) ? (
                                    <button
                                      className="btn btn-sm"
                                      onClick={(e) => handleCart(product)}
                                      style={{
                                        color: "#3bb77e",
                                        backgroundColor: "white",
                                        border: "2px solid #3bb77e",
                                        wordBreak: "keep-all",
                                      }}
                                    >
                                      장바구니에 담김
                                    </button>
                                  ) : (
                                    <button
                                      className="btn btn-sm mobonCart"
                                      onClick={(e) => handleCart(product)}
                                      style={{
                                        wordBreak: "keep-all",
                                      }}
                                    >
                                      장바구니에 담기
                                    </button>
                                  ))
                                )}
                              </td>
                              <td className="remove" data-title="Remove">
                                <a onClick={() => handleDelete(product)}>
                                  <i className="fi-rs-trash"></i>
                                </a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <C.EmptyWrapper>
                        <img
                          src="https://file.caretbio.com/caretbio/45e80cfaa7288992d1f6826ebd3db173.png"
                          alt="empty-cart"
                        />
                        <h4 className="title">
                          위시리스트에 담긴 상품이 없습니다.
                        </h4>
                        <div>
                          <Link href="/products/No-Tape-Box/">
                            <a className="btn text-white">상품 담으러 가기</a>
                          </Link>
                        </div>
                      </C.EmptyWrapper>
                    )}
                  </C.CartProductsWrapper>
                  {wishlist?.map((item, i) => (
                    <C.CartProductsMobile key={i}>
                      {wishlist?.length <= 0 && "위시리스트에 상품이 없습니다."}
                      <C.ProductMobileImg>
                        <img
                          src={item?.main_image}
                          onClick={onClickToDetail(item?.ename, item?.pcode)}
                        />
                      </C.ProductMobileImg>
                      <C.WishlistInfo>
                        <li>
                          <h6
                            className=""
                            onClick={onClickToDetail(item?.ename, item?.pcode)}
                          >
                            {item?.pname}
                          </h6>
                        </li>
                        <li>가격 : {priceComma(item.discount_price)}원</li>
                        <li>
                          재고 :{" "}
                          {item.stock === 0 ? (
                            <span className="text-danger">재고 없음</span>
                          ) : (
                            <span className="">재고 있음</span>
                          )}
                        </li>
                        <li className="action">
                          {/* 모바일에서도 orderType 이 O 일 때만 장바구니 아이콘 노출 */}
                          {isOrderTypeO(item) && (
                            (!isUser
                              ? cartItems?.find(
                                  (cartItem) => cartItem.pcode === item.pcode
                                )
                              : basketsItems?.find(
                                  (basketsItem) =>
                                    basketsItem.pcode === item.pcode
                                )) ? (
                              <a
                                onClick={(e) => handleCart(item)}
                                onMouseOver={() =>
                                  setMouseOn({
                                    ...mouseOn,
                                    [item.pcode]: [true, false],
                                  })
                                }
                                onMouseLeave={() =>
                                  setMouseOn({
                                    ...mouseOn,
                                    [item.pcode]: [false, false],
                                  })
                                }
                              >
                                <i className="fi-rs-shopping-cart-check" />
                                {mouseOn[item.pcode]?.[0] && (
                                  <C.BtnInfo>장바구니 담김</C.BtnInfo>
                                )}
                              </a>
                            ) : (
                              <a
                                onClick={(e) => handleCart(item)}
                                onMouseOver={() =>
                                  setMouseOn({
                                    ...mouseOn,
                                    [item.pcode]: [true, false],
                                  })
                                }
                                onMouseLeave={() =>
                                  setMouseOn({
                                    ...mouseOn,
                                    [item.pcode]: [false, false],
                                  })
                                }
                              >
                                <i className="fi-rs-shopping-cart-add" />
                                {mouseOn[item.pcode]?.[0] && (
                                  <C.BtnInfo>장바구니 담기</C.BtnInfo>
                                )}
                              </a>
                            )
                          )}
                          <a
                            className="danger ml-10"
                            onClick={(e) => handleCart(item)}
                            onMouseOver={() =>
                              setMouseOn({
                                ...mouseOn,
                                [item.pcode]: [false, true],
                              })
                            }
                            onMouseLeave={() =>
                              setMouseOn({
                                ...mouseOn,
                                [item.pcode]: [false, false],
                              })
                            }
                          >
                            <i className="fi-rs-trash"></i>
                            {mouseOn[item.pcode]?.[1] && (
                              <C.BtnInfo>삭제하기</C.BtnInfo>
                            )}
                          </a>
                        </li>
                      </C.WishlistInfo>
                    </C.CartProductsMobile>
                  ))}
                </div>
              </div>
            </div>
          )}
        </section>
      </Layout>
    </>
  );
};

const mapStateToProps = (state) => ({
  cartItems: state.cart,
  basketsItems: state.baskets.items,
});

const mapDispatchToProps = {
  isLoading,
  isLoaded,
  addToCart,
  insertBasketsAction,
  fetchBasketsAction,
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Wishlist);
